module.exports = __webpack_public_path__ + "static/media/linkedin-podcast.e99bf388.svg";